import {Children} from 'react';

import {ComboboxItem} from '../combo-box-item.component';
import {DefaultItem} from '../combo-box-item-default.component';
import {ComboboxGroup} from '../combo-box-group.component';

import type {ReactElement, ReactNode, JSXElementConstructor} from 'react';

import type {ComboboxItemProps} from '../combo-box-item.component';

export function iterateItems<T>(
    children: ReactNode,
    callback: (child: ReactElement<ComboboxItemProps<T>>) => unknown,
) {
    Children.forEach(children, child => {
        if (child && typeof child === 'object' && 'type' in child) {
            const {type} = child;

            if (type === ComboboxItem || type === DefaultItem) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                callback(child as unknown as ReactElement<ComboboxItemProps<T>, string | JSXElementConstructor<any>>);
            }

            if (type === ComboboxGroup) {
                const currentChildProps = child.props as Record<string, unknown>;

                iterateItems<T>(currentChildProps?.children as ReactNode, callback);
            }
        }
    });
}
